import React from 'react';
import PropTypes from 'prop-types';
import { injectIntl } from 'react-intl';
import { Button, Glyphicon } from 'react-bootstrap';
import IntlComponent from 'axway-react-intl';

class ModelInfo extends React.Component {
	constructor(props) {
		super(props);
		IntlComponent.init(this);
	}

	render() {
		return (
			<div className="model-info-container">
				<div className="model-info">
					<div className="model-name">
						<span>{this.props.modelName || ''}</span>
						{this.props.onEdit && (
							<Button
								key="edit"
								className="iconic"
								onClick={this.props.onEdit}
							>
								<Glyphicon glyph=" gg icon-GG-pencil" />
							</Button>
						)}
					</div>
					<div className="model-connector">
						<span className="connector-label">{this.intl.formatMsg('Connector')}</span>
						<span className="value">{this.props.modelConnector || ''}</span>
					</div>
					{this.props.modelDescription && (
						<div>
							<div className="model-description">{this.props.modelDescription || ''}</div>
						</div>
					)}
				</div>
				{this.props.children && (
					<div>
						{this.props.children}
					</div>
				)}
			</div>
		);
	}
}

ModelInfo.propTypes = {
	modelName: PropTypes.string,
	modelConnector: PropTypes.string,
	modelDescription: PropTypes.string,
	onEdit: PropTypes.func
};

export default injectIntl(ModelInfo);
